import { render, staticRenderFns } from "./CircleQuestionnaireButton.vue?vue&type=template&id=d5847370&scoped=true"
import script from "./CircleQuestionnaireButton.vue?vue&type=script&lang=js"
export * from "./CircleQuestionnaireButton.vue?vue&type=script&lang=js"
import style0 from "./CircleQuestionnaireButton.vue?vue&type=style&index=0&id=d5847370&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d5847370",
  null
  
)

export default component.exports